"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionContext = exports.SessionContext = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "SessionContext", { enumerable: true, get: function () { return shared_1.SessionContext; } });
Object.defineProperty(exports, "useSessionContext", { enumerable: true, get: function () { return shared_1.useSessionContext; } });
